import React, { Component } from 'react'
import PropTypes from 'prop-types'

import CSSModules from 'react-css-modules'
import FontIcon from 'react-toolbox/lib/font_icon'
import { Flex, Box } from 'reflexbox'

import styles from './styles.scss'

const TimelinePoint = (props) => {
  let { className } = props

  let pointClasses = `${styles.point} ${className}`
  return (
    <div class={pointClasses} />
  )
}

TimelinePoint.propTypes = {
}

export default CSSModules(TimelinePoint, styles)
